import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
import { motion } from 'framer-motion';
export function ThemeToggle() {
  const {
    theme,
    toggleTheme
  } = useTheme();
  return <motion.button whileTap={{
    scale: 0.9
  }} onClick={toggleTheme} className={`
        p-3 rounded-2xl transition-colors
        ${theme === 'dark' ? 'bg-gray-800 text-yellow-400' : 'bg-orange-100 text-orange-500'}
      `} data-id="element-540">
      {theme === 'dark' ? <Moon className="w-5 h-5" data-id="element-541" /> : <Sun className="w-5 h-5" data-id="element-542" />}
    </motion.button>;
}